import { NavigationRoutes } from 'common/constants';

const navigateByAcl = {
  'flight-sales.view': NavigationRoutes.TicketSalesView,
  'flight-purchases.view': NavigationRoutes.FlightPurchasesView,
  'hotel-sales.view': NavigationRoutes.HotelSalesView,
  'hotel-purchases.view': NavigationRoutes.HotelPurchasesView,
  'cruise-sales.view': NavigationRoutes.CruiseSalesView,
  'cruise-purchases.view': NavigationRoutes.CruisePurchasesView,
  'document-sales.view': NavigationRoutes.TravelDocumentSalesView,
  'document-purchases.view': NavigationRoutes.DocumentPurchasesView,
  'activity-sales.view': NavigationRoutes.ActivitySalesView,
  'activity-purchases.view': NavigationRoutes.ActivityPurchasesView,
  'tour-sales.view': NavigationRoutes.ToursalesView,
  'reports.tour-detail-show': NavigationRoutes.TourDetailReport,
  'product-sales.view': NavigationRoutes.ProductSalesView,
  'product-purchases.view': NavigationRoutes.ProductPurchasesView,
  'flight-sales.page': NavigationRoutes.TicketSalesView,
  'flight-purchases.page': NavigationRoutes.FlightPurchasesView,
  'hotel-sales.page': NavigationRoutes.HotelSalesView,
  'hotel-purchases.page': NavigationRoutes.HotelPurchasesView,
  'cruise-sales.page': NavigationRoutes.CruiseSalesView,
  'cruise-purchases.page': NavigationRoutes.CruisePurchasesView,
  'document-sales.page': NavigationRoutes.TravelDocumentSalesView,
  'document-purchases.page': NavigationRoutes.DocumentPurchasesView,
  'activity-sales.page': NavigationRoutes.ActivitySalesView,
  'activity-purchases.page': NavigationRoutes.ActivityPurchasesView,
  'tour-sales.page': NavigationRoutes.ToursalesView,
  'product-sales.page': NavigationRoutes.ProductSalesView,
  'product-purchases.page': NavigationRoutes.ProductPurchasesView,
};

export default navigateByAcl;
